// Regions where the MSRP/Wholesale price-update self-service flow is
// disabled. Empty for now — DE and NL (both BDE) were originally on a
// fixed-price contract and gated out, but business has since enabled the
// flow for those markets. Kept as an extension point so future markets can
// be gated again without re-introducing the call sites.
const PRICE_UPDATE_DISABLED_REGIONS = [] as const;

type PriceUpdateDisabledRegion = (typeof PRICE_UPDATE_DISABLED_REGIONS)[number];

export const isPriceUpdateDisabledForRegion = (region: string | undefined): boolean =>
  region !== undefined && (PRICE_UPDATE_DISABLED_REGIONS as readonly string[]).includes(region as PriceUpdateDisabledRegion);
